module.exports = "https://cdn-assessment.mathletics.com/app/116/assets/images/01888f59e4ca633e47a4b51ddae9ced7.svg";